/**
 * 呼叫中心-智能轮呼
 */
import { ContentTypeEnum } from '@/enums/axios'
import request from '@/utils/axios'

const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}

// 轮呼列表
export const callRoundTaskList = (data: any) =>
  request.post('/call/call-round-task/callRoundTaskList', data, jsonHeaderConfig)
// 新建轮呼任务
export const addCallRoundTask = (data: any) =>
  request.post('/call/call-round-task/v2addCallRoundTask', data, jsonHeaderConfig)
// 添加轮呼任务模板下载
export const roundCallTaskTemplate = '/call/call-round-task-add-tmp/download/importTemplate'
// 轮呼任务-号码导入
export const roundCallTaskImport = (data: any) =>
  request.upload({
    url: '/call/call-round-task-add-tmp/import',
    data
  })
// 分页查询任务号码列表
export const callRoundTableTmpQuery = (data: any) =>
  request.post('/call/call-round-task-add-tmp/query', data, jsonHeaderConfig)
// 呼叫中心-根据任务id查询轮呼任务
export const callRoundSelectByTaskId = (data: any) =>
  request.post('/call/call-round-task/callRoundSelectByTaskId', data)
// 轮呼任务-户删除任务
export const deleteRoundTaskCommon = (data: any) =>
  request.post('/call/call-round-task/deleteRoundTaskCommon', data, jsonHeaderConfig)
// 轮播客户列表接口
export const selectRoundCallContactPages = (data: any) =>
  request.post('/call/callRoundContactInfo/selectRoundCallContactPages', data, jsonHeaderConfig)
// 轮呼已联系查询已接通未接通数量
export const queryContactedCountByCondition = (data: any) =>
  request.post('/call/callRoundContactInfo/queryContactedCountByCondition', data, jsonHeaderConfig)
// 获取轮呼任务当前状态
export const getTaskStatus = (data: any) =>
  request.post('/call/call-round-task/getTaskStatus', data)
// 新增或编辑客户
export const insertOrUpdateRound = (data: any) =>
  request.post('/call/callRoundUncontactInfo/insertOrUpdate', data, jsonHeaderConfig)
// 轮呼任务新建-批量添加表格数据
export const batchInertToRoundTask = (data: any) =>
  request.post('/call/call-round-task-add-tmp/v2batchInertToRoundTask', data, jsonHeaderConfig)
// 轮呼任务新建-批量添加表格数据
export const roundBatchInertToRoundTask = (data: any) =>
  request.post('/call/call-round-task-add-tmp/roundBatchInertToRoundTask', data, jsonHeaderConfig)
// 删除待联系轮呼客户
export const delUncontactOrder = (data: any) =>
  request.post('/call/callRoundUncontactInfo/delUncontactOrder', data)
// 获取轮呼配置
export const queryRoundCallConf = (data: any) =>
  request.post('/call/callRoundContactInfo/queryRoundCallConf', data, jsonHeaderConfig)
// 更新轮呼间隔时间
export const updateRoundCallConf = (data: any) =>
  request.post('/call/callRoundContactInfo/updateRoundCallConf', data, jsonHeaderConfig)
// 添加到轮呼、添加到待联系
export const addToContactedProcess = (data: any) =>
  request.post('/call/callRoundUncontactInfo/addToContactedProcess', data, jsonHeaderConfig)
// 轮呼-已联系-添加到待联系人进度
export const getRoundCallImportProgress = (data: any) =>
  request.post('/call/callRoundUncontactInfo/getImportProgress', data)
// 开始轮呼或获取下一个联系人信息接口
export const startAndGetContactInfo = (data: any) =>
  request.post('/call/callRoundContactInfo/startAndGetContactInfo', data, jsonHeaderConfig)
// 关闭此次轮呼
export const roundCallshutdown = (data: any) =>
  request.post('/call/callRoundContactInfo/shutdown', data, jsonHeaderConfig)
// 呼叫中心-初始化话机信息接口
export const initCallDeviceInfo = (data: any) =>
  request.post('/call/device/initCallDeviceInfo', data, jsonHeaderConfig)
// 检查sim卡是否已绑定电话号码
export const callCenterSimBoundStatus = (data: any) =>
  request.post('/call/callCenter/check/simBoundStatus', data, jsonHeaderConfig)
// 同步轮呼客户通话状态
export const syncRoundCallStatus = (data: any) =>
  request.post('/call/callRoundContactInfo/syncRoundCallStatus', data, jsonHeaderConfig)
// 获取下一个用户信息用作倒计时展示
export const getNextContactInfo = (data: any) =>
  request.post('/call/callRoundContactInfo/getNextContactInfo', data)
// 再次呼叫
export const roundCallRecall = (data: any) =>
  request.post('/call/callRoundContactInfo/recall', data)
// 删除轮呼任务号码
export const callRoundTableTmpDelete = (data: any) =>
  request.post('/call/call-round-task-add-tmp/delete', data, jsonHeaderConfig)
// 添加或修改任务号码至临时
export const callRoundTableTmpAddOrEdit = (data: any) =>
  request.post('/call/call-round-task-add-tmp/addOrEdit', data, jsonHeaderConfig)
// 轮呼客户关联机构客户
export const roundCallRelateCustomer = (data: any) =>
  request.post('/call/callRoundContactInfo/relateCustomer', data, jsonHeaderConfig)
// 轮呼详情页-模版导入
export const roundCallTemplateImport = (data: any) =>
  request.upload({
    url: '/call/callRoundUncontactInfo/templateImport',
    data
  })
// 电脑唤起App开始轮呼
export const pcEvokeMobileStartRoundCall = (data: any) =>
  request.post('/call/callRoundContactInfo/v2PcEvokeMobileStartRoundCall', data, jsonHeaderConfig)
// Pc唤起手机轮呼过程中关联新建客户操作
export const rcProcessRelateNewCustomer = (data: any) =>
  request.post('/call/callCenter/rcProcessRelateNewCustomer', data, jsonHeaderConfig)
// 轮呼任务-下载导入结果接口
export const roundCallTaskdownloadFailResult = '/call/call-round-task-add-tmp/download/failResult'
